import { useTranslation } from '@klv/hooks/useTranslation';
import SelectInput from '@klv/molecules/form-field/select';

import type { TColorVariant } from '@klv/shared/styles/types';

const supportReasonLabelTagList = [
  {
    label: 'New device',
    tag: 'new_device',
  },
  {
    label: 'New phone number',
    tag: 'new_phone_number',
  },
  {
    label: 'Lost access to the authenticator app',
    tag: 'lost_access_authenticator_app',
  },
  {
    label: 'Did not receive SMS code',
    tag: 'sms_code',
  },
];

export const MfaSupportSelectReason =
  ({ backgroundColor = 'light' }: { backgroundColor: TColorVariant; }) => {
    const { t } = useTranslation();
    return (
      <SelectInput
        backgroundColor={backgroundColor}
        label={t('organisms_forms_accountAccessForm_form_mfa_support_reason')}
        name={'mfaSupportReason'}
      >
        <option value="" disabled hidden>
          {t('organisms_forms_accountAccessForm_form_mfa_support_reason')}
        </option>
        {supportReasonLabelTagList.map((tag) => {
          return (
            <option value={tag.label} key={tag.label}>
              {t(`organisms_forms_accountAccessForm_form_mfa_support_reason_${tag.tag}`)}
            </option>
          );
        })}
      </SelectInput>
    );
  };
